import { useQuery } from 'react-query';
import queryClient from '@/queryClient';
import { apiSdk } from '@/httpClient';
import { DEFAULT_GET_ALL_PAGE_SIZE, DEFAULT_PAGE_SIZE } from '@/config';

const all_countries_key = 'all_countries_key';
export const useGetAllCountries = () => {
  return useQuery(all_countries_key, async () => {
    return await apiSdk.CommonService.getCountries({
      orderBy: 'name',
      orderByAsc: true,
      pageSize: DEFAULT_GET_ALL_PAGE_SIZE,
    });
  });
};

export const clearAllCountriesCache = () => queryClient.removeQueries(all_countries_key);

const get_popular_hotel = 'get_popular_hotel';
export const useGetAllPopularHotels = () => {
  return useQuery(get_popular_hotel, async () => {
    return await apiSdk.LandingService.getPopularHotels();
  });
};

const get_bookmark_hotels = 'get_bookmark_hotels';
export const useGetBookmarkHotels = (pageSize?: number) => {
  return useQuery(get_bookmark_hotels, async () => {
    return await apiSdk.HotelBookmarkService.getHotelBookmarks({
      pageSize: pageSize || DEFAULT_GET_ALL_PAGE_SIZE,
      orderBy: 'createdAt',
      orderByAsc: false,
    });
  });
};

const get_bookmark_hotel_codes = 'get_bookmark_hotel_codes';
export const useGetBookmarkHotelCodes = () => {
  return useQuery(get_bookmark_hotel_codes, async () => {
    return await apiSdk.HotelBookmarkService.getHotelBookmarkCodes();
  });
};
export const clearBookmarkHotelsData = () => {
  queryClient.removeQueries([get_bookmark_hotel_codes, get_bookmark_hotels]);
};
export const clearAndReloadBookmarkHotelsData = () => {
  clearBookmarkHotelsData();
  return Promise.all([queryClient.refetchQueries([get_bookmark_hotel_codes]), queryClient.refetchQueries([get_bookmark_hotels])]);
};

const get_pick_of_this_week = 'get_pick_of_this_week';
export const useGetPickOfWeekHotels = () => {
  return useQuery(get_pick_of_this_week, async () => {
    return await apiSdk.LandingService.getPickOfWeekHotels();
  });
};

const get_slider_images = 'get_slider_images';
export const useGetSliderImages = () => {
  return useQuery(get_slider_images, async () => {
    return await apiSdk.LandingService.getSliderImages();
  });
};

const get_booking_history = 'get_booking_history';
export const useGetBookingHistory = (pageSize?: number) => {
  return useQuery(get_booking_history, async () => {
    return await apiSdk.AgentBookingService.getBookingHistories({ limit: pageSize || DEFAULT_PAGE_SIZE });
  });
};
